import Vue from 'vue'
import VueRouter, {RouteConfig} from 'vue-router'
import Dashboard from '../views/Dashboard.vue'
import Comptage from '../views/Comptage.vue'
import Enrichissement from '../views/Enrichissement.vue'
import Qualite from '../views/Qualite.vue'
import Panier from '../views/Panier.vue'
import User from '../views/User.vue'
import NotFound from '../views/NotFound.vue'

Vue.use(VueRouter);


const routes: Array<RouteConfig> = [
    {
        path: '/',
        name: 'Dashboard',
        component: require('@/views/Dashboard.vue').default,
    },
    {
        path: '/login',
        name: 'Login',
        component: require('@/views/Dashboard.vue').default,
        props: (route) => ({code: route.query.code})
    },
    {
        path: '/comptage',
        name: 'Comptage',
        component: () => import('@/views/Comptage.vue')
    },
    {
        path: '/comptage/:id',
        name: 'Comptage',
        component: () => import('@/views/Comptage.vue')
    },
    {
        path: '/enrichissement',
        name: 'Enrichissement',
        component: () => import('@/views/Enrichissement.vue')
    },
    {
        path: '/enrichissement/:id',
        name: 'Enrichissement',
        component: () => import('@/views/Enrichissement.vue')
    },
    {
        path: '/qualite',
        name: 'Qualite',
        component: () => import('@/views/Qualite.vue')
    },
    {
        path: '/qualite/:id',
        name: 'Qualite',
        component: () => import('@/views/Qualite.vue')
    },
    {
        path: '/panier',
        name: 'Panier',
        component: () => import('@/views/Panier.vue')
    },
    {
        path: '/user',
        name: 'User',
        component: () => import('@/views/User.vue')
    },
    {
        path: "*",
        name: 'NotFound',
        component: () => import('@/views/NotFound.vue')
    }
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
});

export default router
